export default "__VITE_ASSET__eosC7leD__"